import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { OrientationProvider, useOrientation } from './context/OrientationContext';
import LoadingScreen from './Components/LoadingScreen';
import './css/App.css';
import './css/ServicePages.css';
import sitemapHandler from './server/sitemap';

// Import homepage components directly for faster initial load
import HomePageLandscape from './Components/HomePageLandscape';
import HomePagePortrait from './Components/HomePagePortrait';

// Lazy load all other pages
const BlogList = lazy(() => import('./pages/BlogList'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminBlog = lazy(() => import('./pages/AdminBlog'));
const Sitemap = lazy(() => import('./pages/Sitemap'));
const FlatRoofs = lazy(() => import('./pages/FlatRoofs'));
const PitchedRoofs = lazy(() => import('./pages/PitchedRoofs'));
const RoofRepairs = lazy(() => import('./pages/RoofRepairs'));
const Contact = lazy(() => import('./pages/Contact'));

const AppRoutes = () => {
  const { isPortrait } = useOrientation();
  const HomePage = isPortrait ? HomePagePortrait : HomePageLandscape;

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/blog" element={
        <Suspense fallback={<LoadingScreen />}>
          <BlogList />
        </Suspense>
      } />
      <Route path="/blog/:slug" element={
        <Suspense fallback={<LoadingScreen />}>
          <BlogPost />
        </Suspense>
      } />
      <Route path="/admin/login" element={
        <Suspense fallback={<LoadingScreen />}>
          <AdminLogin />
        </Suspense>
      } />
      <Route path="/admin/blog" element={
        <Suspense fallback={<LoadingScreen />}>
          <AdminBlog />
        </Suspense>
      } />
      <Route path="/sitemap.xml" element={
        <Suspense fallback={<LoadingScreen />}>
          <Sitemap />
        </Suspense>
      } />
      <Route path="/services/flat-roofs" element={
        <Suspense fallback={<LoadingScreen />}>
          <FlatRoofs />
        </Suspense>
      } />
      <Route path="/services/pitched-roofs" element={
        <Suspense fallback={<LoadingScreen />}>
          <PitchedRoofs />
        </Suspense>
      } />
      <Route path="/services/roof-repairs" element={
        <Suspense fallback={<LoadingScreen />}>
          <RoofRepairs />
        </Suspense>
      } />
      <Route path="/contact" element={
        <Suspense fallback={<LoadingScreen />}>
          <Contact />
        </Suspense>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const handleSitemap = async (req, res) => {
  if (req.path === '/sitemap.xml') {
    return sitemapHandler(req, res);
  }
};

const App = () => {
  return (
    <HelmetProvider>
      <OrientationProvider>
        <Router>
          <AppRoutes />
        </Router>
      </OrientationProvider>
    </HelmetProvider>
  );
};

export default App;
